// import React from "react";
// import WhatsAppIcon from '@mui/icons-material/WhatsApp';

// export default function WhatsAppButton() {
//   const phoneNumber = "918237084546"; // your phone in international format
//   const message = "Hello! I would like to know more about the admission process and courses at MIBM.";
//   const whatsappLink = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

//   return (
//     <a 
//       href={whatsappLink} 
//       target="_blank" 
//       rel="noopener noreferrer"
//       style={{
//         position: "fixed",
//         bottom: "20px",
//         right: "100px",
//         backgroundColor: "#25D366",
//         color: "white",
//         // padding: "3px 4px",
//         borderRadius: "20px",
//         textDecoration: "none",
//         fontWeight: "bold",
//         boxShadow: "4px 6px 13px rgba(0,0,0,0.9)",
//         zIndex: "1000",
//         height:"50px",
//         width:"50px",
//         display:"flex",
//         justifyContent:"center",
//         alignItems:"center"
//       }}
//     >
//       {/* 💬 Chat on WhatsApp    */}
//        <WhatsAppIcon style={{fontSize:"70px"}}/>
//     </a>
//   );
// }


import React from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

export default function WhatsAppButton() {
  const phoneNumber = "918237084546"; // your phone in international format
  const message =
    "Hello! I would like to know more about the admission process and courses at MIBM.";
  const whatsappLink = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
    message
  )}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "calc(50px + env(safe-area-inset-bottom))", // mobile safe area
        right: "110px",
        backgroundColor: "#25D366",
        color: "white",
        borderRadius: "50%",
        textDecoration: "none",
        boxShadow: "4px 6px 13px rgba(0,0,0,0.9)",
        height: "50px",
        width: "50px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        transform: "translateZ(0)", // mobile repaint fix
        willChange: "transform",
        zIndex: 9999, // always on top

      }}
    >
      <WhatsAppIcon style={{ fontSize: "70px" }} />
    </a>
  );
}
